import { ref } from 'vue';
import { isTest } from '@/utils/environments/environments';

const refCounter = ref(0);
export const useRefCounter = () => {
  const getNextRef = (): number => {
    refCounter.value += 1;
    return refCounter.value;
  };

  const resetRefCounter = (): void => {
    if (isTest()) {
      refCounter.value = 0;
    } else {
      throw new Error('Do not reset refCounter except for test cases!');
    }
  };

  return {
    refCounter,
    getNextRef,
    resetRefCounter,
  };
};
